import { ListItemText, Menu, MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    borderRadius: '12px',
    boxShadow:
      '-1px 2px 8px rgba(0, 0, 0, 0.15), 2px -1px 8px rgba(0, 0, 0, 0.15)',
    margin: '0',
    padding: '0',
  },
})((props) => (
  <Menu
    elevation={0}
    getcontentanchorel={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    width: '275px',
    '&:hover': {
      color: '#374151',
      backgroundColor: 'rgba(229, 231, 235, 0.8)',
    },
    '&:focus': {
      color: '#374151',
      backgroundColor: 'rgba(229, 231, 235, 0.8)',
    },
  },
}))(MenuItem);

const GrayStyledMenuItem = withStyles(() => ({
  root: {
    width: '275px',
    '&:hover': {
      color: '#374151',
      backgroundColor: 'rgba(229, 231, 235, 0.8) !important',
    },
    '&:focus': {
      color: '#374151',
      backgroundColor: 'rgba(229, 231, 235, 0.8) !important',
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent !important',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgba(229, 231, 235, 0.8) !important',
    },
    '&.Mui-selected.Mui-focusVisible': {
      backgroundColor: 'rgba(229, 231, 235, 0.8) !important',
    },
  },
}))(MenuItem);

export const CustomDropdownReadOnly = (props) => {
  return (
    <StyledMenu
      id="customized-menu"
      anchorEl={props.anchorEl}
      keepMounted
      open={Boolean(props.anchorEl)}
      onClose={props.handleClose}
    >
      {props.list.map((option, key) => (
        <StyledMenuItem key={key}>
          <ListItemText
            style={{
              textAlign: 'center',
              fontFamily: 'Poppins',
              fontWeight: '400',
              fontSize: '16px',
            }}
            primary={props.getOptionLabel(option)}
          />
        </StyledMenuItem>
      ))}
    </StyledMenu>
  );
};

export const CustomDropdownWithSelect = (props) => {
  const isGray = props.variant === 'gray';
  const MenuItemComponent = isGray ? GrayStyledMenuItem : StyledMenuItem;
  return (
    <StyledMenu
      id="customized-menu"
      anchorEl={props.anchorEl}
      keepMounted
      open={Boolean(props.anchorEl)}
      onClose={props.handleClose}
      PaperProps={isGray ? { style: { backgroundColor: '#F3F4F6' } } : {}}
    >
      {props.list.map((option, index) => (
        <MenuItemComponent
          key={index}
          selected={props.value?.type === option.type}
          onClick={() => props.setValue(index)}
        >
          <ListItemText
            style={{
              textAlign: 'left',
              fontFamily: 'Poppins',
              fontWeight: '400',
              fontSize: '16px',
            }}
            primary={props.getOptionLabel(option)}
          />
          {props.value?.type === option.type ? (
            <img
              style={{ float: 'right' }}
              src="Images/icon-check.png"
              alt="check"
            />
          ) : null}
        </MenuItemComponent>
      ))}
    </StyledMenu>
  );
};
